/*
 * Copyright (c) Nexign, JSC, 2021-2022.
 */
/**
 * Функция для склонения русских слов
 *
 * @author Yakov Gushchin
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.12.0
 */

/**
 * Пример использования: declination(5,'комментари|й|я|ев')
 *
 * @param      {number}  num  Число, для которого будет расчитано окончание
 * @param      {string}  words   Слово и варианты окончаний для 1|2|1 (1 комментарий, 2 комментария, 100 комментариев)
 * @return     {string}  Cлово с правильным окончанием
 */
const declination = (num: number, words: string) => {
    const w = words.split('|');
    const n = Math.abs(num); // abs на случай отрицательного значения
    return n % 10 === 1 && n % 100 !== 11
        ? w[0] + w[1]
        : (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? w[0] + w[2] : w[0] + w[3]);
}

export default declination;
